import { MbeEnFlag } from '@/components/icons/MbeEnFlag';
import { MbeFrFlag } from '@/components/icons/MbeFrFlag';
import { MbeItFlag } from '@/components/icons/MbeItFlag';
import { MbeEsFlag } from '@/components/icons/MbeEsFlag';
import type { ILanguage } from '@/types';

export const languages: ILanguage[] = [
  {
    id: 'it',
    label: 'it',
    icon: MbeItFlag,
  },
  {
    id: 'en',
    label: 'en',
    icon: MbeEnFlag,
  },
  {
    id: 'fr',
    label: 'fr',
    icon: MbeFrFlag,
  },
  {
    id: 'es',
    label: 'es',
    icon: MbeEsFlag,
  },
];

export const apiUrl = process.env.REACT_APP_API_URL;
